<template>
  <el-tabs tab-position="left" :value="selectedReportId" @tab-click="handleTabClick">
    <el-tab-pane v-for="name in reportIds" :label="name" :name="name" :key="name">
      <el-button size="small" @click="refresh">
        <i class="fa fa-refresh" aria-hidden="true"></i>
      </el-button>
      <div v-for="image in cachedImages" :key="image[0]">
        <img :src="'data:image/png;base64,' + image[1]" />
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<style lang="scss" scoped>
  button {
    position: absolute;
    right: 0;
  }

  img {
    width: 100%;
    max-width: 497px;
  }
</style>


<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  props: ['serverId'],

  data () {
    return {
      selectedReportId: null
    }
  },

  mounted () {
    this.setInitialReport()
  },

  computed: {
    reportIds () {
      return Object.keys(this.reports).sort()
    },
    cachedImages () {
      if (this.serverId === this.selectedServerId) {
        return this.getCachedImages(this.selectedReportId)
      }
    },
    ...mapState('servers', {
      selectedServerId: state => state.selectedEntityId,
      reports: state => state.entities[state.selectedEntityId]
    }),
    ...mapGetters('servers', ['getCachedImages'])
  },

  watch: {
    selectedServerId () {
      this.setInitialReport()
    }
  },

  methods: {
    setInitialReport () {
      if (this.serverId === this.selectedServerId && this.reportIds[0]) {
        this.selectedReportId = this.reportIds[0]
        this.fetchImagesIfNotPresent()
      }
    },
    handleTabClick (tab) {
      this.selectedReportId = tab.label
      this.fetchImagesIfNotPresent()
    },
    refresh () {
      this.fetchImages({ server: this.serverId, report: this.selectedReportId })
    },
    fetchImagesIfNotPresent () {
      if (this.cachedImages.length === 0) {
        this.refresh()
      }
    },
    ...mapActions('servers', [
      'fetchImages'
    ])
  }
}
</script>




// WEBPACK FOOTER //
// src/components/servers/Server.vue